import {
  GET_PRODUCT_REQ,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_ERROR,
  GET_CATEGORIES_REQ,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_ERROR,
  UPDATE_SHIPPINGCOST_REQ,
  UPDATE_SHIPPINGCOST_SUCCESS,
  UPDATE_SHIPPINGCOST_ERROR,
  GET_SHIPPINGCOST_REQ,
  GET_SHIPPINGCOST_SUCCESS,
  GET_SHIPPINGCOST_ERROR,
  UPDATE_PRODUCT_REQ,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_ERROR,
  POST_PRODUCT_REQ,
  POST_PRODUCT_SUCCESS,
  POST_PRODUCT_ERROR,
  POST_CUSTOMPRODUCT_REQ,
  POST_CUSTOMPRODUCT_SUCCESS,
  POST_CUSTOMPRODUCT_ERROR,
  GET_BASEMIX_CATEGORIES_REQ,
  GET_BASEMIX_CATEGORIES_SUCCESS,
  GET_BASEMIX_CATEGORIES_ERROR,
  GET_BASEMIXES_REQ,
  GET_BASEMIXES_SUCCESS,
  GET_BASEMIXES_ERROR,
  GET_ADDITIVES_REQ,
  GET_ADDITIVES_SUCCESS,
  GET_ADDITIVES_ERROR,
  GET_BASEMIXES_CATEGORIES_REQ,
  GET_BASEMIXES_CATEGORIES_SUCCESS,
  GET_BASEMIXES_CATEGORIES_ERROR,
  POST_BASEMIX_REQ,
  POST_BASEMIX_SUCCESS,
  POST_BASEMIX_ERROR,
  GET_TEMPLATE_REQ,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_ERROR,
  POST_FILE_REQ,
  POST_FILE_SUCCESS,
  POST_FILE_ERROR,
  POST_SHIPPINGCOST_REQ,
  POST_SHIPPINGCOST_SUCCESS,
  POST_SHIPPINGCOST_ERROR,
  GET_CATEGORIES_PRODUCT_REQ,
  GET_CATEGORIES_PRODUCT_SUCCESS,
  GET_CATEGORIES_PRODUCT_ERROR,
  GET_ADDITIVE_PRODUCT_SUCCESS,
  GET_ADDITIVE_PRODUCT_ERROR,
  GET_BASEMIX_PRODUCT_SUCCESS,
  GET_BASEMIX_PRODUCT_ERROR,
  GET_ADDITIVE_PRODUCT_REQ,
  GET_BASEMIX_PRODUCT_REQ,
  UPDATE_CUSTOM_PRODUCT_SUCCESS,
  UPDATE_CUSTOM_PRODUCT_ERROR,
  UPDATE_CUSTOM_PRODUCT_REQ,
  POST_BASEMIXES_REQ,
  POST_BASEMIXES_ERROR,
  POST_BASEMIXES_SUCCESS,
  POST_BASEMIX_CATEGORIES_REQ,
  POST_BASEMIX_CATEGORIES_SUCCESS,
  POST_BASEMIX_CATEGORIES_ERROR,
  UPDATE_BASEMIX_CATEGORIES_REQ,
  UPDATE_BASEMIX_CATEGORIES_SUCCESS,
  UPDATE_BASEMIX_CATEGORIES_ERROR,
  POST_ADDITIVES_CATALOG_REQ,
  POST_ADDITIVES_CATALOG_SUCCESS,
  POST_ADDITIVES_CATALOG_ERROR,
  UPDATE_ADDITIVES_CATALOG_REQ,
  UPDATE_ADDITIVES_CATALOG_SUCCESS,
  UPDATE_ADDITIVES_CATALOG_ERROR,
  POST_CATEGORY_CATALOG_ERROR,
  POST_CATEGORY_CATALOG_REQ,
  POST_CATEGORY_CATALOG_SUCCESS,
  UPDATE_CATEGORY_CATALOG_REQ,
  UPDATE_CATEGORY_CATALOG_SUCCESS,
  UPDATE_CATEGORY_CATALOG_ERROR,
  DELETE_CATALOG_PRODUCT_SUCCESS,
  DELETE_CATALOG_PRODUCT_ERROR,
  DELETE_CATALOG_PRODUCT_REQ,
  TAB_PRODUCT_KEY_SUCCESS,
  TAB_PRODUCT_KEY_ERROR,
  TAB_PRODUCT_KEY_REQ,
} from "../constants";

export default class CatalogAction {
  static getCategoriesReq(params) {
    return {
      type: GET_CATEGORIES_REQ,
      params,
    };
  }

  static getCategoriesSuccess(payload) {
    return {
      type: GET_CATEGORIES_SUCCESS,
      payload,
    };
  }
  static getCategoriesError(error) {
    return {
      type: GET_CATEGORIES_ERROR,
      error,
    };
  }
  static getProductReq(params, isTrue) {
    return {
      type: GET_PRODUCT_REQ,
      params,
      isTrue,
    };
  }
  static getProductSuccess(payload, metaData) {
    return {
      type: GET_PRODUCT_SUCCESS,
      payload,
      metaData,
    };
  }
  static getProductError(error) {
    return {
      type: GET_PRODUCT_ERROR,
      error,
    };
  }
  static getShipingCostReq(params) {
    return {
      type: GET_SHIPPINGCOST_REQ,
      params,
    };
  }

  static getShipingCostSuccess(payload) {
    return {
      type: GET_SHIPPINGCOST_SUCCESS,
      payload,
    };
  }
  static getShipingCostError(error) {
    return {
      type: GET_SHIPPINGCOST_ERROR,
      error,
    };
  }

  static postShippingCostReq(payload) {
    return {
      type: POST_SHIPPINGCOST_REQ,
      payload,
    };
  }
  static postShippingCostSuccess(res) {
    return {
      type: POST_SHIPPINGCOST_SUCCESS,
      res,
    };
  }
  static postShippingCostFailure(error) {
    return {
      type: POST_SHIPPINGCOST_ERROR,
      error,
    };
  }
  static updateShipingCostReq(params, id) {
    return {
      type: UPDATE_SHIPPINGCOST_REQ,
      params,
      id,
    };
  }
  static updateShipingCostSuccess(payload) {
    return {
      type: UPDATE_SHIPPINGCOST_SUCCESS,
      payload,
    };
  }
  static updateShipingCostError(error) {
    return {
      type: UPDATE_SHIPPINGCOST_ERROR,
      error,
    };
  }
  static updateProductReq(params, id, activestatus, cb) {
    return {
      type: UPDATE_PRODUCT_REQ,
      params,
      id,
      activestatus,
      cb,
    };
  }

  static updateProductSuccess(payload) {
    return {
      type: UPDATE_PRODUCT_SUCCESS,
      payload,
    };
  }
  static updateProductError(error) {
    return {
      type: UPDATE_PRODUCT_ERROR,
      error,
    };
  }

  static updateCustomProductReq(payload, id, cb) {
    return {
      type: UPDATE_CUSTOM_PRODUCT_REQ,
      payload,
      id,
      cb,
    };
  }

  static updateCustomProductSuccess(payload) {
    return {
      type: UPDATE_CUSTOM_PRODUCT_SUCCESS,
      payload,
    };
  }
  static updateCustomProductError(error) {
    return {
      type: UPDATE_CUSTOM_PRODUCT_ERROR,
      error,
    };
  }

  static postProductReq(payload, cb, isTrue) {
    return {
      type: POST_PRODUCT_REQ,
      payload,
      cb,
      isTrue,
    };
  }

  static postProductSuccess(payload) {
    return {
      type: POST_PRODUCT_SUCCESS,
      payload,
    };
  }
  static postProductError(error) {
    return {
      type: POST_PRODUCT_ERROR,
      error,
    };
  }

  static postCustomProductReq(payload, cb) {
    return {
      type: POST_CUSTOMPRODUCT_REQ,
      payload,
      cb,
    };
  }

  static postCustomProductSuccess(payload) {
    return {
      type: POST_CUSTOMPRODUCT_SUCCESS,
      payload,
    };
  }
  static postCustomProductError(error) {
    return {
      type: POST_CUSTOMPRODUCT_ERROR,
      error,
    };
  }
  static getBasemixCategoriesReq(params) {
    return {
      type: GET_BASEMIX_CATEGORIES_REQ,
      params,
    };
  }
  static getBasemixCategoriesSuccess(payload) {
    return {
      type: GET_BASEMIX_CATEGORIES_SUCCESS,
      payload,
    };
  }
  static getBasemixCategoriesError(error) {
    return {
      type: GET_BASEMIX_CATEGORIES_ERROR,
      error,
    };
  }

  static getBasemixesReq(params) {
    return {
      type: GET_BASEMIXES_REQ,
      params,
    };
  }
  static getBasemixesSuccess(payload) {
    return {
      type: GET_BASEMIXES_SUCCESS,
      payload,
    };
  }
  static getBasemixesError(error) {
    return {
      type: GET_BASEMIXES_ERROR,
      error,
    };
  }

  static getAdditivesReq(params) {
    return {
      type: GET_ADDITIVES_REQ,
      params,
    };
  }
  static getAdditivesSuccess(payload) {
    return {
      type: GET_ADDITIVES_SUCCESS,
      payload,
    };
  }
  static getAdditivesError(error) {
    return {
      type: GET_ADDITIVES_ERROR,
      error,
    };
  }

  static getBasemixesCategoriesReq(params) {
    return {
      type: GET_BASEMIXES_CATEGORIES_REQ,
      params,
    };
  }
  static getBasemixesCategoriesSuccess(payload) {
    return {
      type: GET_BASEMIXES_CATEGORIES_SUCCESS,
      payload,
    };
  }
  static getBasemixesCategoriesError(error) {
    return {
      type: GET_BASEMIXES_CATEGORIES_ERROR,
      error,
    };
  }
  static postBasemixReq(payload, urlParams, cb) {
    return {
      type: POST_BASEMIX_REQ,
      payload,
      urlParams,
      cb,
    };
  }
  static postBasemixSuccess(payload) {
    return {
      type: POST_BASEMIX_SUCCESS,
      payload,
    };
  }
  static postBasemixError(error) {
    return {
      type: POST_BASEMIX_ERROR,
      error,
    };
  }

  static getTemplateReq(params) {
    return {
      type: GET_TEMPLATE_REQ,
      params,
    };
  }
  static getTemplateSuccess(payload) {
    return {
      type: GET_TEMPLATE_SUCCESS,
      payload,
    };
  }
  static getTemplateError(error) {
    return {
      type: GET_TEMPLATE_ERROR,
      error,
    };
  }

  static postFileReq(payload) {
    return {
      type: POST_FILE_REQ,
      payload,
    };
  }
  static postFileSuccess(payload) {
    return {
      type: POST_FILE_SUCCESS,
      payload,
    };
  }
  static postFileError(error) {
    return {
      type: POST_FILE_ERROR,
      error,
    };
  }

  static getCategoriesProductReq(params) {
    return {
      type: GET_CATEGORIES_PRODUCT_REQ,
      params,
    };
  }

  static getCategoriesProductSuccess(payload, metaData) {
    return {
      type: GET_CATEGORIES_PRODUCT_SUCCESS,
      payload,
      metaData,
    };
  }
  static getCategoriesProductError(error) {
    return {
      type: GET_CATEGORIES_PRODUCT_ERROR,
      error,
    };
  }

  static getAdditiveProductReq(params) {
    return {
      type: GET_ADDITIVE_PRODUCT_REQ,
      params,
    };
  }

  static getAdditiveProductSuccess(payload, metaData) {
    return {
      type: GET_ADDITIVE_PRODUCT_SUCCESS,
      payload,
      metaData,
    };
  }
  static getAdditiveProductError(error) {
    return {
      type: GET_ADDITIVE_PRODUCT_ERROR,
      error,
    };
  }

  static getBasemixProductReq(params) {
    return {
      type: GET_BASEMIX_PRODUCT_REQ,
      params,
    };
  }

  static getBasemixProductSuccess(payload, metaData) {
    return {
      type: GET_BASEMIX_PRODUCT_SUCCESS,
      payload,
      metaData,
    };
  }
  static getBasemixProductError(error) {
    return {
      type: GET_BASEMIX_PRODUCT_ERROR,
      error,
    };
  }

  static postBasemixesReq(payload, cb) {
    return {
      type: POST_BASEMIXES_REQ,
      payload,
      cb,
    };
  }
  static postBasemixesSuccess(payload) {
    return {
      type: POST_BASEMIXES_SUCCESS,
      payload,
    };
  }
  static postBasemixesError(error) {
    return {
      type: POST_BASEMIXES_ERROR,
      error,
    };
  }
  static postBasemixCategoriesReq(payload, cb) {
    return {
      type: POST_BASEMIX_CATEGORIES_REQ,
      payload,
      cb,
    };
  }
  static postBasemixCategoriesSuccess(payload) {
    return {
      type: POST_BASEMIX_CATEGORIES_SUCCESS,
      payload,
    };
  }
  static postBasemixCategoriesError(error) {
    return {
      type: POST_BASEMIX_CATEGORIES_ERROR,
      error,
    };
  }

  static updateBasemixCategoriesReq(payload, id, cb) {
    return {
      type: UPDATE_BASEMIX_CATEGORIES_REQ,
      payload,
      id,
      cb,
    };
  }
  static updateBasemixCategoriesSuccess(payload) {
    return {
      type: UPDATE_BASEMIX_CATEGORIES_SUCCESS,
      payload,
    };
  }
  static updateBasemixCategoriesError(error) {
    return {
      type: UPDATE_BASEMIX_CATEGORIES_ERROR,
      error,
    };
  }

  static postAdditiveCatalogReq(payload, cb) {
    return {
      type: POST_ADDITIVES_CATALOG_REQ,
      payload,
      cb,
    };
  }
  static postAdditiveCatalogSuccess(payload) {
    return {
      type: POST_ADDITIVES_CATALOG_SUCCESS,
      payload,
    };
  }
  static postAdditiveCatalogError(error) {
    return {
      type: POST_ADDITIVES_CATALOG_ERROR,
      error,
    };
  }

  static updateAdditiveCatalogReq(payload, id, cb) {
    return {
      type: UPDATE_ADDITIVES_CATALOG_REQ,
      payload,
      id,
      cb,
    };
  }
  static updateAdditiveCatalogSuccess(payload) {
    return {
      type: UPDATE_ADDITIVES_CATALOG_SUCCESS,
      payload,
    };
  }
  static updateAdditiveCatalogError(error) {
    return {
      type: UPDATE_ADDITIVES_CATALOG_ERROR,
      error,
    };
  }

  static postCategoryCatalogReq(payload, cb) {
    return {
      type: POST_CATEGORY_CATALOG_REQ,
      payload,
      cb,
    };
  }
  static postCategoryCatalogSuccess(payload) {
    return {
      type: POST_CATEGORY_CATALOG_SUCCESS,
      payload,
    };
  }
  static postCategoryCatalogError(error) {
    return {
      type: POST_CATEGORY_CATALOG_ERROR,
      error,
    };
  }

  static updateCategoryCatalogReq(payload, id, cb) {
    return {
      type: UPDATE_CATEGORY_CATALOG_REQ,
      payload,
      id,
      cb,
    };
  }
  static updateCategoryCatalogSuccess(payload) {
    return {
      type: UPDATE_CATEGORY_CATALOG_SUCCESS,
      payload,
    };
  }
  static updateCategoryCatalogError(error) {
    return {
      type: UPDATE_CATEGORY_CATALOG_ERROR,
      error,
    };
  }

  static delteCatalogProductReq(id, payload, cb) {
    return {
      type: DELETE_CATALOG_PRODUCT_REQ,
      id,
      payload,
      cb,
    };
  }
  static delteCatalogProductSuccess(payload) {
    return {
      type: DELETE_CATALOG_PRODUCT_SUCCESS,
      payload,
    };
  }
  static delteCatalogProductError(error) {
    return {
      type: DELETE_CATALOG_PRODUCT_ERROR,
      error,
    };
  }

  static getTabProductKeyReq(id) {
    return {
      type: TAB_PRODUCT_KEY_REQ,
      id,

    };
  }
  static getTabProductKeySuccess(payload) {
    return {
      type: TAB_PRODUCT_KEY_SUCCESS,
      payload,
    };
  }
  static getTabProductKeyError(error) {
    return {
      type: TAB_PRODUCT_KEY_ERROR,
      error,
    };
  }
}
